import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { getBanksUrl, getWalletsUrl } from '../shared/utils/api-urls.utils';
import { Bank } from '../models/bank.model';
import { AuthService } from './auth/auth.service';

/**
 * Service for bank-related operations
 */
@Injectable({
  providedIn: 'root'
})
export class BankService {
  readonly #http = inject(HttpClient);
  private readonly auth = inject(AuthService);

  /**
   * Retrieve all supported banks
   */
  getBanks(): Observable<Bank[]> {
    const token = this.auth.token;
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.#http.get<Bank[]>(getBanksUrl(), { headers });
  }

    /**
   * DELETE /wallets/{walletId}
   * — Delete a wallet
   */
  deleteWallet(walletId: number | string): Observable<void> {
    const headers = this.authHeaders();
    // getWalletsUrl() already returns ".../wallets"
    const url = `${getWalletsUrl()}/${walletId}`;
    return this.#http.delete<void>(url, { headers });
  }

    /** helper to always attach Authorization header */
  private authHeaders(): HttpHeaders {
    const token = this.auth.token;
    return new HttpHeaders().set('Authorization', `Bearer ${token}`);
  }
}
